import { types, actions } from './requests'
export const GETWORKLIST_TYPES = {
    ...types('GETWORKLIST'),
}
export const GETWORKLIST_ACTIONS = {
    ...actions('GETWORKLIST'),
}
